var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"tag":"li","to":_vm.to,"active-class":"","exact-active-class":"active"}},[_c('a',[_c('i',{class:`icon mdi mdi-${_vm.icon}`}),_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),_c('span',{class:_vm.countClass},[_vm._v(_vm._s(_vm.count))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }